export default __webpack_public_path__ + "static/media/trustpilotLogo.b8251527.svg";